const app = {
  APP_TRANSITION_TIME: 300,
};

Object.assign(window, app);
